import {Component, ElementRef, ViewChild, forwardRef, Renderer2, OnInit, OnDestroy} from '@angular/core';
import {FileUploader} from "ng2-file-upload";
import {AlertController} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core";
import {UploadService} from "./upload.service";
import {AppAuth} from "../../core/auth";
import {environment} from "../../config/environment";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FileEntry} from "./file-entry.model";
import {ToastService} from "../../core/toast.service";
import {RoleService} from "../../core/role.service";

export const UPLOADERCOMPONENT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UploaderComponent),
  multi: true
};

@Component({
  selector: 'app-uploader',
  templateUrl: 'uploader.component.html',
  providers: [UPLOADERCOMPONENT_VALUE_ACCESSOR, UploadService]
})
export class UploaderComponent implements ControlValueAccessor, OnInit, OnDestroy {

  public uploader: FileUploader;
  @ViewChild('uploadInput') uploadElRef: ElementRef;
  @ViewChild('progressBar') progressBarElRef: ElementRef;
  public fileEntries: FileEntry[] = [];
  public value: any;
  public disabled: boolean;
  public accept: string;
  role: string;
  roleSubscription: any;
  roleObs: any;
  onModelChange: Function = () => {
  };
  onModelTouched: Function = () => {
  };

  constructor(
    private auth: AppAuth,
    private uploadService: UploadService,
    private toast: ToastService,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private renderer: Renderer2,
    private roleService: RoleService
  ) {

    this.uploader = new FileUploader({
      url: environment.API + '/upload/file',
      headers: [{
        name: 'Accept',
        value: 'application/json, text/plain, */*'
      }]
    });

    this.auth.getAuthStatus()
      .subscribe((token) => {
        this.auth.getToken().then(token => {
          this.uploader.authToken = token ? 'Bearer ' + token : null;
        });
      });

    this.uploader.onAfterAddingFile = (item) => {
      item.withCredentials = false;
      item.upload();

      // Clear input file selection, so you could select the same file if needed
      this.uploadElRef.nativeElement.value = ''
    };

    this.uploader.onCompleteItem = (item, response) => {

      // Add finished item to attachments
      try {
        let data = JSON.parse(response);
        if(data.entry) {
          this.addEntry(data.entry);
        }
      } catch (e) {
        console.log(e);
      }
    };

    this.uploader.onProgressAll = (progress) => {
      this.renderer.setStyle(this.progressBarElRef.nativeElement, 'width', progress + '%');
    };

    this.uploader.onErrorItem = (item, response, status, headers) => {
      item.remove();
      let msg = 'You\'re file could not be uploaded.';

      try{
        let data = JSON.parse(response);
        if(data.file){
          msg = data.file.join(' ');
        }
      } catch(e){
        console.log(e);
      }

      setTimeout(() => toast.show(msg), 50);
    };
  }

  ngOnInit(): any {
    this.roleObs = this.roleService.getRole();
    this.roleSubscription = this.roleObs
      .subscribe(role => this.role = role);
  }

  ngOnDestroy(): any {
    this.roleSubscription.unsubscribe();
  }

  showDeleteModal(entry) {
    let confirm = this.alertCtrl.create({
      title: this.translate.instant('uploader.delete_file'),
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('global.delete'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.deleteFile(entry));
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  deleteFile(file){
    this.uploadService.deleteFile(file.id)
      .subscribe(success => {
        this.removeEntry(file);
        this.toast.show(success.message)
      });
  }

  private addEntry(entry) {
    this.fileEntries.push(entry);

    if (this.isSingleFileUploader()) {
      this.value = entry;
    }

    this.onModelChange(this.value);
  }

  private removeEntry(file) {
    this.fileEntries.splice(this.fileEntries.indexOf(file), 1);

    if (this.isSingleFileUploader()) {
      this.value = null;
    }

    this.onModelChange(this.value);
  }

  isSingleFileUploader() {
    return !(this.value instanceof Array);
  }

  writeValue(value) {
    this.value = value;

    // Initialize single file uploader
    if (this.isSingleFileUploader()) {
      this.fileEntries = [];
      this.accept = 'image/*';
      if(this.value){
        this.addEntry(this.value);
      }
    }else{
      this.accept = '';
      this.fileEntries = this.value;
    }
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/uploader/uploader.component.ts